document.addEventListener('toggle', event => {
  if (!event.target.matches('.am-hotspot') || !event.target.open) return;
  event.target.parentElement.querySelectorAll('.am-hotspot[open]').forEach(el => { if (el !== event.target) el.open = false; });
}, true);
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.am-hotspot[open]').forEach(el => { el.open = false; el.querySelector('summary').focus(); });
});
const alarmMateHeroes = new WeakMap();
function initAlarmMate(root = document) {
  root.querySelectorAll('.am-hero').forEach(hero => {
    if (alarmMateHeroes.has(hero)) return;
    const slides = [...hero.querySelectorAll('.am-slide')];
    const copies = [...hero.querySelectorAll('.am-hero-copy')];
    const copyArea = document.createElement('div');
    copyArea.className = 'am-hero-copies';
    copies[0]?.before(copyArea);
    copies.forEach(copy => { copy.hidden = false; copyArea.append(copy); });
    const status = hero.querySelector('[data-am-status]');
    const pause = hero.querySelector('[data-am-pause]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    const animations = new Set();
    const listen = (el, type, fn) => el?.addEventListener(type, fn, {signal:abort.signal});
    const motion = () => !reduced.matches && document.body.dataset.amMotion !== 'off';
    const duration = () => Number(document.body.dataset.amDuration) || 650;
    const ease = 'cubic-bezier(.4,0,.2,1)';
    let index = 0, requested = 0, timer, busy = false, queued, destroyed = false, revision = 0;
    let paused = reduced.matches || !!window.Shopify?.designMode;
    function animate(element, frames, options = {}) {
      const animation = element.animate(frames, {duration:duration(),easing:ease,...options});
      animations.add(animation);
      animation.finished.then(() => animations.delete(animation)).catch(() => animations.delete(animation));
      return animation;
    }
    function activate(next, announce) {
      index = next;
      slides.forEach((el, i) => {el.setAttribute('aria-hidden',String(i !== index));el.style.zIndex = i === index ? '2' : '1';});
      copies.forEach((el, i) => {
        el.inert = i !== index;
        el.setAttribute('aria-hidden',String(i !== index));
        el.style.opacity = i === index ? '1' : '0';
        el.style.visibility = i === index ? 'visible' : 'hidden';
      });
      if (status) {status.setAttribute('aria-live',announce ? 'polite' : 'off');status.textContent = `${index + 1} / ${slides.length}`;}
    }
    function settle() {
      slides.forEach((el, i) => {el.hidden = i !== index;});
      copies.forEach((el, i) => {el.style.visibility = i === index ? 'visible' : 'hidden';});
      busy = false;
      if (queued) {const next = queued;queued = null;show(next.index,next.announce);}
      else schedule();
    }
    async function show(next, announce = false) {
      requested = (next + slides.length) % slides.length;
      stop();
      if (busy) {queued = {index:requested,announce};return;}
      if (requested === index) {schedule();return;}
      busy = true;
      const transition = ++revision;
      const target = requested;
      const image = slides[target].querySelector('img');
      if (image && !image.complete) {image.loading = 'eager';await image.decode().catch(() => {});}
      if (destroyed || transition !== revision) return;
      const previous = index;
      slides[target].hidden = false;
      activate(target,announce);
      if (!motion()) {settle();return;}
      const outgoing = copies[previous];
      outgoing.style.visibility = 'visible';
      animate(outgoing,[{opacity:1},{opacity:0}],{duration:Math.min(280,duration()*.4)}).finished.then(() => {if (previous !== index) outgoing.style.visibility = 'hidden';}).catch(() => {});
      const textAnimations = [...copies[target].children].map((child, order) => animate(child,[{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:duration()*.72,delay:100+order*(Number(document.body.dataset.amStagger)||60),fill:'backwards',easing:'cubic-bezier(.22,1,.36,1)'}));
      const fade = animate(slides[target],[{opacity:0},{opacity:1}]);
      Promise.allSettled([fade.finished,...textAnimations.map(animation => animation.finished)]).then(() => {if (!destroyed && transition === revision) settle();});
    }
    function stop() {clearTimeout(timer);}
    function schedule() {
      stop();
      if (destroyed || busy || paused || hero.dataset.autoplay !== 'true' || slides.length < 2 || document.hidden || hero.matches(':hover') || hero.contains(document.activeElement)) return;
      timer = setTimeout(() => show(index+1),Math.max(4,Number(hero.dataset.interval)||6)*1000);
    }
    function syncPause() {
      if (!pause) return;
      pause.textContent = paused ? '▶' : 'Ⅱ';
      pause.setAttribute('aria-label',paused ? 'Play slideshow' : 'Pause slideshow');
    }
    listen(hero.querySelector('[data-am-prev]'),'click',() => show(requested-1,true));
    listen(hero.querySelector('[data-am-next]'),'click',() => show(requested+1,true));
    listen(pause,'click',() => {paused = !paused;syncPause();schedule();});
    listen(hero,'mouseenter',stop);listen(hero,'mouseleave',schedule);
    listen(hero,'focusin',stop);listen(hero,'focusout',() => setTimeout(schedule,0));
    listen(document,'visibilitychange',schedule);
    listen(reduced,'change',() => {
      if (!reduced.matches) return;
      revision += 1;requested = index;paused = true;queued = null;syncPause();stop();
      animations.forEach(animation => animation.cancel());
      settle();
    });
    alarmMateHeroes.set(hero,{
      select(block) {paused = true;syncPause();show(slides.indexOf(block));},
      destroy() {destroyed = true;stop();animations.forEach(animation => animation.cancel());abort.abort();alarmMateHeroes.delete(hero);}
    });
    activate(0,false);slides.forEach((el,i) => {el.hidden = i !== 0;});syncPause();schedule();
  });
}
initAlarmMate();
document.addEventListener('shopify:section:load', event => initAlarmMate(event.target));
document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.am-hero').forEach(hero => alarmMateHeroes.get(hero)?.destroy()));
document.addEventListener('shopify:block:select', event => {
  const slide = event.target.closest('.am-slide');
  if (slide) alarmMateHeroes.get(slide.closest('.am-hero'))?.select(slide);
});

function initReviewTickers(root = document) {
 root.querySelectorAll('.am-reviews').forEach(section => {
  if(section.classList.contains('am-ticker-ready') || section.dataset.reviewLayout !== 'ticker') return;
  const track = section.querySelector('.am-reviews-grid');
  if(!track || !track.children.length) return;
  [...track.children].forEach(card => {const copy=card.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.removeAttribute('data-shopify-editor-block');copy.inert=true;track.append(copy);});
  section.classList.add('am-ticker-ready');
  const button=section.querySelector('.am-ticker-pause');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  function setPaused(paused){section.classList.toggle('am-ticker-paused',paused);button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'Play reviews':'Pause reviews';}
  setPaused(reduced.matches || !!window.Shopify?.designMode);
  reduced.addEventListener('change',()=>{if(reduced.matches)setPaused(true);});
  button.addEventListener('click',()=>setPaused(!section.classList.contains('am-ticker-paused')));
 });
}
initReviewTickers();
document.addEventListener('shopify:section:load',event=>initReviewTickers(event.target));


document.addEventListener('toggle',event=>{const detail=event.target;if(!detail.matches('.am-faq-item')||!detail.open)return;const section=detail.closest('.am-faq');if(section.dataset.singleOpen==='true')section.querySelectorAll('.am-faq-item[open]').forEach(other=>{if(other!==detail)other.open=false;});},true);


